import type { RotuloObraProps } from "./types-rotulo-obra";
import { useRotuloObra } from "./use-rotulo-obra";
import { RotuloObraView } from "./view-rotulo-obra";

/**
 * Rótulo de tela que identifica a obra (ADR 0018): `ID - nome da embarcação`, trocado sozinho por `ID - sigla` pela largura
 * e, se nem a sigla couber, reticências. Tooltips, filtro e chips ficam em `ID - sigla` (`formatarIdentificacaoObra`).
 */
export function RotuloObra(props: RotuloObraProps) {
  const vm = useRotuloObra(props);

  return <RotuloObraView {...props} {...vm} />;
}

export type * from "./types-rotulo-obra";
